import React, { Component } from 'react';
// import classNames from 'classnames'
import styles from './index.css';


import Gallery   from '../../components/Gallery';
import GalleryMobile   from '../../components/GalleryMobile';

export default class GalleryComponent extends Component {   
  getHeightContent = (c,r) =>{
    this.props.getHeightContent(c,r);
  }
  mobile(){
    if(document.documentElement.clientWidth < 1025) return true;
    return false;
  }
  render() {
    return (
      <div className={styles['contentIndex']} >  
        {!this.mobile()&&<Gallery 
            steps             = {this.props.steps} 
            getHeightContent  = {this.getHeightContent}
            valueScroll       = {this.props.goUpDown}
            data              = {this.props.data}
            ADMIN_URL         = {this.props.ADMIN_URL}
        />}
        { this.mobile()&&<GalleryMobile 
                          data = {this.props.data}
                          ADMIN_URL         = {this.props.ADMIN_URL}
                        />}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/GalleryContent/index.js